import React, {Component} from "react";
import {Col} from "react-bootstrap";
import {CommonExplanation} from "./CommonExplanation";


export class MultiplierExplanation extends Component {

	render() {
		return (
			<Col>
				<p className={"font-italic"}>
					Adjusting the number of trees
					planted in each Tree Planting Group.
				</p>
				<strong>
					Here is a break-even estimation
					with your planting group amounts{" "}
					multiplied by {this.props.multiplier}:
				</strong>
				<CommonExplanation
					breakEven={this.props.breakEven}
					currentBenefits={this.props.currentBenefits}
					forecastBenefits={this.props.forecastBenefits}
				/>
			</Col>
		)
	}
}
